import React from "react";
import { string } from "prop-types";

import {
  ENTITY_TYPES,
  SellerInquiry as ControlledSellerInquiry
} from "../../../interested-seller-inquiry";
import {
  useStore,
  useUIStoreData,
  useUserStoreData,
  useValuationStoreData
} from "../../utilities/mobx/storeHooks";

const SellerInquiry = ({ rootElementId }) => {
  const { store } = useStore();
  const { uiStore } = store;
  const { isSellerInquiryModalOpen, sellerInquiryType } = useUIStoreData();
  const { email, name, phoneNumber } = useUserStoreData();
  const { propertyId } = useValuationStoreData();

  return (
    <ControlledSellerInquiry
      entityId={propertyId}
      entityType={propertyId ? ENTITY_TYPES.property : null}
      handleRequestClose={uiStore.closeSellerInquiryModal}
      inquiryType={sellerInquiryType}
      isOpen={isSellerInquiryModalOpen}
      rootElementId={rootElementId}
      userContactDetails={{ email, name, phone_number: phoneNumber }}
    />
  );
};

SellerInquiry.propTypes = {
  rootElementId: string.isRequired
};

export default SellerInquiry;
